/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import {
  AutocompleteLoadMoreEvent,
  DialogInput,
  FormMode,
  getControlValue,
  NotificationService,
  setControlValue,
  WaitingService,
} from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';
import { CSMasterBusinessService } from '../../resources/cs-master-business.service';
import { CloneSource, CSMasterListItem } from '../../resources/cs-master.model';

export interface CSMasterCloneDialogConfig {
  item?: CSMasterListItem;
}

@Component({
  selector: 'gh-cs-master-clone-dialog',
  template: require('./cs-master-clone-dialog.component.html'),
  styles: [require('./cs-master-clone-dialog.component.scss')],
})
export class CSMasterCloneDialogComponent implements OnInit, DialogInput<CSMasterCloneDialogConfig> {
  input: CSMasterCloneDialogConfig;
  form: FormState<CSMasterListItem>;

  constructor(private dialogRef: MatDialogRef<any>,
              private notificationService: NotificationService,
              private waitingService: WaitingService,
              private formStateBuilder: FormStateBuilder,
              private businessService: CSMasterBusinessService) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        ...this.input.item,
        cloneSource: CloneSource.CSMaster,
      },
      mode: FormMode.CreateMode,
      children: {
        cloneSource: void 0,
        cloneSourceItem: { required: true },
      },
    });

  }

  get isCloneSourceItem(): boolean {
    return isNotNil(getControlValue(this.form.group, 'cloneSourceItem'));
  }

  onClone(): void {
    this.dialogRef.close({
      value: getControlValue(this.form.group, 'cloneSourceItem'),
      source: getControlValue(this.form.group, 'cloneSource'),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSourceChange(value: CloneSource): void {
    setControlValue(this.form.group, 'cloneSourceItem', void 0);
  }

  loadData($event: AutocompleteLoadMoreEvent): void {
    switch (getControlValue(this.form.group, 'cloneSource')) {
      case CloneSource.CSMaster:
        this.loadColorSelectionMaster($event);
        break;
      case CloneSource.JobCS:
        this.loadJobColorSelection($event);
        break;
      default:
        break;
    }
  }

  loadColorSelectionMaster($event: AutocompleteLoadMoreEvent): void {
    const { query, load } = $event;

    load(this.businessService.findCsMasterByName(query));
  }

  loadJobColorSelection($event: AutocompleteLoadMoreEvent): void {
    const { query, load } = $event;

    load(this.businessService.findJobCsByName(query));
  }
}

export const cSMasterCloneDialogRoute = createDialogRoute({
  component: CSMasterCloneDialogComponent,
});
